import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { accessTokenName, loginSuccess, refreshTokenName, resetLogin } from './auth';

export type possibleErrorFormat = { detail?: string; error?: string | { data: unknown }; data?: unknown }

let refreshPending = false
let refreshed = false

const retryDelay = 6000
const retrySamples = 20

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))

axios.interceptors.response.use(
	(resp) => resp,
	async (error: AxiosError<possibleErrorFormat>) => {
		const _resetToLogin = () => {
			resetLogin()
            window.location.pathname = '/login'
		}

		const setTokenToConfig = (cfg: InternalAxiosRequestConfig | undefined, access: string | null | undefined) => {
			if (access && cfg) cfg.headers.Authorization = `Bearer ` + access
		}

		if (error.response?.status === 401) {
			if (error.response && error.response.data && error.response.data.detail === 'No active account found with the given credentials') {
				return error
			}
			if (error.response && !refreshPending) {
				if (!localStorage.getItem(refreshTokenName)) {
					_resetToLogin()
					return error
				}

				refreshed = false

				refreshPending = true

				try {
					const response = await axios.post('/token/refresh/', {
						refresh: localStorage.getItem(refreshTokenName),
					})
					refreshPending = false

					if (response.status === 200) {
						loginSuccess(response.data.access, response.data.refresh)
						refreshed = true
						let config = error.config
						setTokenToConfig(config, response.data.access)
						return axios(config ?? {})
					} else {
						_resetToLogin()
						return error
					}
				} catch (e) {
					// console.log(e)
				}
			}
			if (refreshed) {
				let cfg = error.config
				setTokenToConfig(cfg, localStorage.getItem(accessTokenName))
				return axios(cfg ?? {})
			}
			if (refreshPending && error.config) {
				let cfg = error.config
				if (error.config.url !== '/token/refresh/') {
					for (let i = 0; i < retrySamples; i++) {
						await sleep((retryDelay * i) / retrySamples)
						if (refreshed) {
							setTokenToConfig(cfg, localStorage.getItem(accessTokenName))
							return axios(cfg)
						}
					}
					return error
				}
			}
		}
		return error
	}
)
